import React from 'react';

class LeaguesTable extends React.Component {

  constructor(props) {
		super(props);
		this.createLeagueRow = this.createLeagueRow.bind(this);
	}
			
	render() {
		//console.log('LeaguesTable: RENDER')
		return (
			<div>
				<table className="table table-striped table-hover table-responsive table-sm">
				<tbody>
					<tr>
						{/*<th></th>*/}
						<th>Ligues</th>
						<th>ID</th>
						{/*<th></th>*/}
					</tr>
					{this.props.leagues.map(this.createLeagueRow)}
				</tbody>
				</table>
			</div>
		);
	}
	
	createLeagueRow(league, leagueIdx) {
		return (
			<tr key={league._id}>
				{/*<td><input name={'edit.' + league._id} type="button" onClick={this.editLeague} value="Éditer"/></td>*/}
				<td>{league._id}</td>
				<td>{league.name}</td>
				{/*<td><input name={'del.' + league._id} type="button" onClick={this.handleDeleteLeague} value="Supprimer"/></td>*/}
			</tr>
		);
	}

}

export default LeaguesTable;
